import { Edit, Send, Delete } from "@material-ui/icons";
import React, { useState, useEffect } from "react";
import "./Stories.scss";
import moment from "moment/moment";
import { useLocation, useHistory } from "react-router-dom";
import black from "../../icons/default1.png";
import Dropdown from "../Main/Dropdown/Dropdown";
import config from "../../config/apiConfig";
import Cookies from "js-cookie";
import ReactGA from "react-ga";

export type Draft = {
    id: string;
    avatar: string;
    title: string;
    updatedAt: Date;
};

type Props = {
    drafts: Draft[];
    publish: (id: string) => any;
    delete: (id: string) => any;
};

type Part = {
    id: string;
    title: string;
};

export function mapToDarft(data: { [key: string]: any }): Draft {
    return {
        id: data.id,
        avatar: data.cover_image,
        title: data.title,
        updatedAt: new Date(data.updated_at * 1000),
    };
}

const Drafts: React.FC<Props> = ({ drafts, publish, delete: onDelete }) => {
    const [parts, setParts] = useState<Part[][]>([]);
    const { pathname } = useLocation();
    const intent = pathname.split("/")[1];
    const history = useHistory();

    useEffect(() => {
        loadParts();
    }, []);

    const loadParts = async () => {
        const formData = new FormData();
        formData.append("session-token", Cookies.get("token") ?? "");
        formData.append("token", config.token);
        const requestParams = {
            method: "POST",
            body: formData,
        };

        const p: Part[][] = [];

        for (let draft of drafts) {
            await fetch(
                config.BASE_URL +
                    "/v1/get/writingtool/story/" +
                    draft.id +
                    "/chapters",
                requestParams
            )
                .then((res) => res.json())
                .then((res) =>
                    p.push(
                        (res.data as any[]).map((prt) => ({
                            ...prt,
                            body: {},
                        }))
                    )
                );
        }

        setParts(p);
    };

    return (
        <React.Fragment>
            {drafts.map((draft, index) => (
                <div className="draft">
                    <div className="image">
                        <img
                            src={
                                draft.avatar.trim() !== ""
                                    ? draft.avatar
                                    : black
                            }
                        />
                    </div>
                    <div className="content">
                        <h5>
                            {draft.title.length > 80
                                ? draft.title.substr(0, 80) + "..."
                                : draft.title}
                        </h5>
                        <p>
                            Last updated on{" "}
                            {moment(draft.updatedAt).format(
                                "Do MMMM YYYY [at] h:mm a"
                            )}
                        </p>
                        <div className="flex">
                            <div className="concat-buttons">
                                <Dropdown
                                    title="Continue Writing"
                                    buttonStyles={{ width: "max-content" }}
                                >
                                    <ul>
                                        {parts[index]?.map((part, index) => (
                                            <li
                                                onClick={() => {
                                                    ReactGA.event({
                                                        category: "My Stories",
                                                        action: "Continue writing",
                                                        label: `${draft.id}-${part.id}`,
                                                    });
                                                    history.push(
                                                        "/" +
                                                            intent +
                                                            "/write?story_id=" +
                                                            draft.id +
                                                            "&chapter_id=" +
                                                            part.id
                                                    );
                                                }}
                                            >
                                                Part {index + 1}: {part.title}
                                            </li>
                                        ))}
                                        <li
                                            className="write"
                                            onClick={() => {
                                                ReactGA.event({
                                                    category: "My Stories",
                                                    action: "Write new part",
                                                    label: draft.id,
                                                });
                                                history.push(
                                                    "/" +
                                                        intent +
                                                        "/write?story_id=" +
                                                        draft.id +
                                                        "&chapter_id=new"
                                                );
                                            }}
                                        >
                                            Write a new part{" "}
                                            <Edit
                                                style={{
                                                    height: "18px",
                                                    width: "18px",
                                                }}
                                            />
                                        </li>
                                    </ul>
                                </Dropdown>
                                <button onClick={() => publish(draft.id)}>
                                    <Send />
                                    Publish
                                </button>
                            </div>
                            <button
                                onClick={() => onDelete(draft.id)}
                                className="icon_button"
                            >
                                <Delete />
                            </button>
                        </div>
                    </div>
                </div>
            ))}
        </React.Fragment>
    );
};

export default Drafts;
